import { Lock } from 'lucide-react';
// INTRODUCE — discreet, paper-form contact.
export default function Introduce() {
  return (
    <div className="bg-[#EFEAE0] text-[#1B1A18]">
      <section className="pt-12 pb-10 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-2 border-[#1B1A18]/30">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#142437] mb-4">— Section IV · Introduction</p>
        <h1 className="font-serif text-5xl lg:text-8xl leading-[0.92] tracking-[-0.02em] max-w-5xl">A letter, <span className="italic text-[#142437]">not a form</span>.</h1>
        <p className="font-serif italic text-lg lg:text-xl text-[#1B1A18]/65 mt-6 max-w-2xl">If a client of the bank has not introduced you, please write to the partners' secretary directly. The letter below is read by a partner. Always.</p>
      </section>

      <section className="max-w-[1100px] mx-auto px-8 lg:px-14 py-16 grid lg:grid-cols-[1fr_1.6fr] gap-12 lg:gap-20">
        <aside>
          <div className="border border-[#1B1A18]/20 bg-[#E5DDC9] p-8">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#142437] mb-3 flex items-center gap-2"><Lock className="w-3 h-3" strokeWidth={1.5} /> The Partners' Secretary</p>
            <p className="font-serif text-2xl">Mrs Eleanor Hartwood</p>
            <p className="text-sm text-[#1B1A18]/65 mt-3 leading-[1.7]">Westmoreland Private Bank<br />14 St James's Square<br />London SW1Y 4LB</p>
            <p className="font-mono text-[11px] text-[#1B1A18]/55 mt-4">+44 20 7993 0801</p>
            <p className="font-mono text-[11px] text-[#142437] mt-1">e.hartwood@westmoreland.partners</p>
          </div>
          <p className="text-sm text-[#1B1A18]/55 leading-[1.7] mt-8">Mrs Hartwood replies, in writing, within five working days. The bank does not maintain a contact-centre. The letter you write is the letter the partner reads.</p>
        </aside>

        {/* Letter-format form */}
        <form className="space-y-7 bg-[#FAF6E8] border border-[#1B1A18]/20 p-8 lg:p-12" onSubmit={(e) => e.preventDefault()}>
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#142437] flex justify-between border-b border-[#1B1A18]/15 pb-4">
            <span>/ Letter of Introduction</span>
            <span className="text-[#1B1A18]/55">REF · WMB-INTRO</span>
          </div>
          <PaperField label="Your name in full" testId="bank-intro-name" />
          <div className="grid sm:grid-cols-2 gap-5">
            <PaperField label="Telephone" type="tel" testId="bank-intro-tel" />
            <PaperField label="Email" type="email" testId="bank-intro-email" />
          </div>
          <PaperField label="Country of residence" testId="bank-intro-country" />
          <div>
            <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#142437] block mb-2">Indicative range of assets</label>
            <select className="w-full bg-transparent border-b border-[#1B1A18]/30 py-3 outline-none focus:border-[#142437] font-serif text-base" data-testid="bank-intro-aum">
              {['$25M — 50M', '$50M — 100M', '$100M — 250M', 'Over $250M', 'Single transaction (private credit)'].map(o => <option key={o}>{o}</option>)}
            </select>
          </div>
          <div>
            <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#142437] block mb-2">Brief letter</label>
            <textarea data-testid="bank-intro-letter" rows="6" placeholder="A line or two on what you would like to discuss…" className="w-full bg-transparent border-b border-[#1B1A18]/30 py-3 outline-none focus:border-[#142437] resize-none font-serif text-base text-[#1B1A18] placeholder:text-[#1B1A18]/30" />
          </div>
          <div className="font-mono text-[10px] text-[#1B1A18]/55 leading-relaxed border-t border-[#1B1A18]/15 pt-4">All correspondence is confidential, encrypted, and read by no one outside the partnership.</div>
          <button type="button" data-testid="bank-intro-submit" className="bg-[#142437] text-[#EFEAE0] px-9 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#1B1A18] transition-colors">Send to the secretary →</button>
        </form>
      </section>
    </div>
  );
}

function PaperField({ label, type = 'text', testId }) {
  return (
    <div>
      <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#142437] block mb-2">{label}</label>
      <input data-testid={testId} type={type} className="w-full bg-transparent border-b border-[#1B1A18]/30 py-3 outline-none focus:border-[#142437] font-serif text-base text-[#1B1A18]" />
    </div>
  );
}
